import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { supabase } from '../../../Supabase/SupabaseClient';
import ServiceShowcase from '../../../Components/ServiceShowcase/ServiceShowcase';
import { CATEGORIAS_POR_ID, resolverSlug } from '../../../config/catalogoServicios';

export default function ServicioDetalle() {
  const { slug: slugParam } = useParams();
  const slug = resolverSlug(slugParam);

  const [servicio, setServicio] = useState(null);
  const [fotos, setFotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let activo = true;

    const cargar = async () => {
      setLoading(true);
      setError(null);

      const { data, error: servicioError } = await supabase
        .from('servicios')
        .select('*')
        .eq('slug', slug)
        .maybeSingle();

      if (!activo) return;

      if (servicioError) {
        setError('No pudimos leer los servicios. Revisá que se haya ejecutado la migración.');
        setLoading(false);
        return;
      }

      if (!data || data.activo === false) {
        setError('Ese servicio no existe o ya no está disponible.');
        setLoading(false);
        return;
      }

      setServicio(data);

      const { data: fotosData } = await supabase
        .from('servicio_fotos')
        .select('*')
        .eq('servicio_id', data.id)
        .order('orden', { ascending: true });

      if (activo) setFotos(fotosData || []);
      setLoading(false);
    };

    window.scrollTo(0, 0);
    cargar();
    return () => {
      activo = false;
    };
  }, [slug]);

  if (loading) {
    return <div className="boda-loading-container">Cargando servicio...</div>;
  }

  if (error) {
    return (
      <div className="boda-error-container">
        <p>{error}</p>
        <Link className="boda-showcase-btn" to="/" style={{ marginTop: 16 }}>
          <span>Volver al inicio</span>
          <span className="boda-showcase-btn-arrow" aria-hidden="true">
            <ArrowLeft size={18} />
          </span>
        </Link>
      </div>
    );
  }

  const portada = fotos.find((f) => f.destacada) || fotos[0];
  const imagenes = [
    portada?.url_foto,
    ...fotos.filter((f) => f !== portada).map((f) => f.url_foto),
    servicio.imagen_url,
    CATEGORIAS_POR_ID[servicio.categoria]?.imagen,
  ].filter(Boolean);

  const galeria = imagenes.map((src, index) => ({
    tipo: 'imagen',
    label: index === 0 ? servicio.nombre : `${servicio.nombre} ${index + 1}`,
    src,
  }));

  const incluye = Array.isArray(servicio.opciones) && servicio.opciones.length
    ? servicio.opciones
    : String(servicio.descripcion || '')
        .split(/\n+/)
        .map((line) => line.trim())
        .filter(Boolean);

  return <ServiceShowcase servicio={servicio} galeria={galeria} incluye={incluye} />;
}
